import React, { useCallback } from 'react';

import { SidePage, Typography, LegacyBox } from '@gogame/components';
import { useMountedState } from '@gogame/hooks-ts';

import AppSelect from './AppSelect';
import RewardPackagesTable from './RewardPackagesTable';
import { useLoadRewardPackages } from './data';

const RewardPackages = ({ onClose, onExited, open }) => {
  const [applicationId, setApplicationId] = useMountedState('');
  const { data, isLoading } = useLoadRewardPackages(applicationId);
  const handleChangeApp = useCallback(
    (_e, v) => {
      setApplicationId(v);
    },
    [setApplicationId]
  );

  return (
    <SidePage
      onClose={onClose}
      onExited={onExited}
      open={open}
      loading={isLoading}
      size={'md'}
    >
      <SidePage.Title title={'Reward Packages'} />
      <SidePage.NewBody fullHeight={false} scroll={false}>
        <AppSelect value={applicationId} onChange={handleChangeApp} />
      </SidePage.NewBody>
      <SidePage.NewBody scroll={false}>
        {applicationId ? (
          data ? (
            <RewardPackagesTable rows={data?.rows} />
          ) : null
        ) : (
          <LegacyBox align={'center'} justifyContent={'center'} grow={1}>
            <Typography>Select application to view rewards</Typography>
          </LegacyBox>
        )}
      </SidePage.NewBody>

      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
    </SidePage>
  );
};

export default RewardPackages;
